//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    var cloneExt = $('.extended-description').clone()

    addToCategoryResultCode()
    rebuildTopCategoryResult()

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on('click', '.js-detail-tab-item', function () {
      var tabContent = $(this).data('content')
      if ($(this).closest('.tab-pane').hasClass('active')) {
        $(this).closest('.tab-pane').removeClass('active in')
      } else {
        var tabPaneSelected = $(
          '.p-detail-tabs-wrapper .tab-pane[id="' + tabContent + '"]',
        )
        $('.p-detail-tabs-wrapper .tab-pane').removeClass('active in')
        tabPaneSelected.addClass('active in')

        $('html, body').stop().animate({
          scrollTop: tabPaneSelected.offset().top,
        })
      }
    })

    $(document).on('click', '.shp-tab', function () {
      var inst = $(this)
      var thisId = inst.attr('data-testid')
      var thisTabs = $(this).closest('.p-detail-tabs-wrapper')

      if (thisId == 'undefined') {
        return false
      }

      if (!inst.hasClass('active')) {
        thisTabs.find('.shp-tab.' + 'active' + '').removeClass('active')
        $(this).addClass('active')
        thisTabs
          .find('.tab-pane.' + 'active' + '')
          .removeClass('active')
          .removeClass('in')
          .removeClass('fade')
        thisTabs
          .find('.tab-pane#' + thisId + '')
          .addClass('active')
          .addClass('fade')
          .addClass('in')
      }

      if ($('#productParameter').length) {
        if ($('#productParameter .extended-description').length == 0) {
          $('.description-inner').append(cloneExt)
          parametersTable = $('#productParameter .extended-description')

          if (turskyDPTCategoryItem) {
            if ($('.category-link').length === 0) {
              setDPTCategoryItem(parametersTable)
            }
          } else {
            $('.detail-parameters tbody').prepend(
              '<tr><th><span class="row-header-label">Kategória<span class="row-header-label-colon">:</span></span></th><td><a href="/mobilne-telefony/">Mobilné telefóny</a></td></tr>',
            )
          }
        }
      }
      return false
    })
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultCategoryItems = []
  var arrayResultTitleItems = []
  var arrayResultCategoryTitleItems = []
  var arrayResultLinkItems = []
  var arrayResultBtnItems = []
  var arrayResultPhoneItems = []
  var arrayResultMobileItems = []
  var arrayResultEmailItems = []
  var arrayResultSideCategory = []
  var mainItem = false
  var anotherItemText = true
  var anotherItemSubtext = true
  var anotherItemLink = true
  var anotherItemBtn = true
  var anotherItemPhone = true
  var anotherItemMobile = true
  var anotherItemEmail = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    item.find('.js-json-input').each(function () {
      input = $(this)
      var dataJson = input.attr('data-json')
      var dataVar = input.attr('data-var')
      if (input.val().length > 0) {
        var inputValue = input.val()
        if (dataVar === 'turskyDPTTitleLang') {
          arrayResultTitleItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'turskyDPTCategoryTitleLang') {
          arrayResultCategoryTitleItems.push(`${dataJson}:"${inputValue}"`)
        }
      }
    })

    if (anotherItemText) {
      if (arrayResultTitleItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">turskyDPTTitleLang</span> = <span class="js-result-value txt-green">{${arrayResultTitleItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemText = false
      }
    }

    if (anotherItemSubtext) {
      if (arrayResultCategoryTitleItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">turskyDPTCategoryTitleLang</span> = <span class="js-result-value txt-green">{${arrayResultCategoryTitleItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemSubtext = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputDivider = inputParent.data('divider')
      var inputType = inputParent.data('type')

      if (inputDivider == true) {
        inputValue = '/' + inputValue
      }

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (input.hasClass('js-json-input')) {
      } else {
        if (blockItemCSS) {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategoryCSS.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
        } else {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategory.push(templateBoxItem)
          arrayResultSideCategory.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
        }
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      if (element.attr('data-type') === 'option') {
        checkboxValue = `"${element.find('select').val()}"`
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var bannerContactSidebar
var bannerContactTemplate
var bannerContactRadius = ''
var bannerContactBG = ''
var bannerContactBGOverlay = ''
var bannerContactBGOverlaySet = ''
var bannerContactBGSide = ''
var bannerContactBorder = ''
var bannerContactRow = ''
var bannerContactIcon = ''

var bannerContactAddonTitle = ''
var bannerContactAddonText = ''
var bannerContactAddonLink = ''

var bannerContactTitle = ''
var bannerContactText = ''
var bannerContactLink = ''
var bannerContactBtn = ''
var bannerContactTextBtn = ''
var bannerContactList = ''

var bannerContactListPhone = ''
var bannerContactListMobile = ''
var bannerContactListEmail = ''

function rebuildTopCategoryResult() {
  turskyDPTAddon = $('#tursky_DPT_active').is(':checked')
  turskyDPTPosition = $('#tursky_DPT_position').val()

  turskyDPTCategoryItem = $('#tursky_DPT_category_item').is(':checked')
  turskyDPTAccordionMobile = $('#tursky_DPT_accordion_mobile').is(':checked')

  turskyDPTTitle = $('#tursky_DPT_title').val()
  turskyDPTCategoryTitle = $('#tursky_DPT_category_title').val()

  // CSS
  let root = document.documentElement

  root.style.setProperty(
    '--dpt-accordion-border-radius',
    $('#tursky_DPT_border_radius').val(),
  )

  root.style.setProperty('--dpt-accordion-BG', $('#tursky_DPT_bgs').val())

  root.style.setProperty(
    '--dpt-accordion-BG-active',
    $('#tursky_DPT_BG-active').val(),
  )

  root.style.setProperty(
    '--dpt-accordion-title-color',
    $('#tursky_DPT_title_color').val(),
  )

  root.style.setProperty(
    '--dpt-accordion-title-color-active',
    $('#tursky_DPT_title_active_color').val(),
  )

  root.style.setProperty(
    '--dpt-category',
    $('#tursky_DPT_category_color').val(),
  )

  root.style.setProperty(
    '--dpt-category-hover',
    $('#tursky_DPT_category_color_hover').val(),
  )

  if (turskyDPTAddon) {
    $('body').addClass('detail-parameter-tab-addon')
    // removeButton()
    if (turskyDPTAccordionMobile) {
      setDPTAccordionMobile()
    } else {
      $('.js-detail-tab-item').remove()
    }

    setDPTText()
    setDPTDesign()

    createDPTTab()
  } else {
    $('body').removeClass('detail-parameter-tab-addon')
    $('.extended-description').insertAfter('.basic-description')
    $('.shp-tab-parameter').remove()
    $('#productParameter').remove()
    $('.shp-tab:not(".active")[data-testid="description"]').trigger('click')
    $('.detail-parameters tbody').prepend(
      '<tr><th><span class="row-header-label">Kategória<span class="row-header-label-colon">:</span></span></th><td><a href="/mobilne-telefony/">Mobilné telefóny</a></td></tr>',
    )
    $('.extended-description h4').remove()
    $('.extended-description .category-link').remove()
    // removeButton()
  }
}

function createDPTTab() {
  var parametersTable

  if ($('#description .extended-description').length) {
    parametersTable = $('#description .extended-description')
  } else {
    parametersTable = $('#productParameter .extended-description')
  }

  if (turskyDPTCategoryItem) {
    if ($('.category-link').length === 0) {
      setDPTCategoryItem(parametersTable)
    } else {
      $(
        '.detail-parameter-tab-addon #productParameter .extended-description h4',
      ).text(turskyDPTCategoryTitleExt)
    }
  } else {
    $('.detail-parameters tbody').prepend(
      '<tr><th><span class="row-header-label">Kategória<span class="row-header-label-colon">:</span></span></th><td><a href="/mobilne-telefony/">Mobilné telefóny</a></td></tr>',
    )
    $('.extended-description h4').remove()
    $('.extended-description .category-link').remove()
  }

  turskyDPTTemplate = `
		<li class="shp-tab shp-tab-parameter" data-testid="productParameter" data-width="115">
			<a href="#productParameter" class="shp-tab-link" role="tab" data-toggle="tab">${turskyDPTTitle}</a>
		</li>`

  var turskyDPTContentTemplate = `
		<div id="productParameter" class="tab-pane fade" role="tabpanel">
				${turskyDPTAccordionMobileTemplate}
				<div class="detail-tab-content">
						<div class="description-inner description-inner--full">
						</div>
				</div>
		</div>`

  if ($('#productParameter').length) {
    $('.shp-tab-parameter').remove()
    $('#productParameter').remove()
    // if (turskyDPTPosition == 0) {
    //   $('.shp-tab-parameter').insertBefore('#p-detail-tabs li:first-child')
    //   $('#productParameter').insertBefore('#tab-content .tab-pane:first-child')
    // } else {
    //   $('.shp-tab-parameter').insertAfter(
    //     '#p-detail-tabs li:nth-child(' + turskyDPTPosition + ')',
    //   )
  }
  if (turskyDPTPosition == 0) {
    $(turskyDPTTemplate).insertBefore('#p-detail-tabs li:first-child')
    $(turskyDPTContentTemplate).insertBefore(
      '#tab-content .tab-pane:first-child',
    )
  } else {
    $(turskyDPTTemplate).insertAfter(
      '#p-detail-tabs li:nth-child(' + turskyDPTPosition + ')',
    )
    $(turskyDPTContentTemplate).insertAfter(
      '#tab-content .tab-pane:nth-child(' + turskyDPTPosition + ')',
    )
  }
  $('#tab-content #productParameter .description-inner').append(parametersTable)
}

// Set detail tabs as accordion on mobile
function setDPTAccordionMobile() {
  $('.p-detail-tabs-wrapper .tab-pane').each(function () {
    if ($(this).find('.detail-tab-content').length == 0) {
      $(this).find('> *').wrapAll('<div class="detail-tab-content"></div>')
    }
  })

  $('#tab-content .tab-pane').each(function () {
    if ($(this).find('.detail-tab-item').length != 0) {
      return false
    }
    const item = $(this)
    const type = item.attr('id')
    const elementText = $('.shp-tab-link[href="#' + type + '"]').text()
    const template = `<span class="detail-tab-item js-detail-tab-item" data-content="${type}">${elementText}</span>`
    item.prepend(template)
  })
}

function setDPTCategoryItem(element) {
  if (element.find('tr:first-child td').length == 0) {
    return false
  }
  const detailParamaterTabCategory = element.find('tr:first-child td').html()
  element.find('tr:first-child').remove()

  const detailParamaterTabCategoryTemplate = `
		<h4>${turskyDPTCategoryTitleExt}</h4>
		<div class="category-link">
			<span class="category-link__icon">
				<span></span>
				<span></span>
				<span></span>
			</span>
			${detailParamaterTabCategory}
		</div>
	`

  element.append(detailParamaterTabCategoryTemplate)
}

// Set design for button in detail
function setDPTDesign() {
  if (turskyDPTAccordionMobile) {
    turskyDPTAccordionMobileTemplate = `<span class="detail-tab-item js-detail-tab-item" data-content="productParameter">${turskyDPTTitle}</span>`
    $('body').addClass('detail-parameter-tab-addon-accordion')
  } else {
    turskyDPTAccordionMobileTemplate = ''
    $('body').removeClass('detail-parameter-tab-addon-accordion')
  }
}

// Set text for button in detail
function setDPTText() {
  if (turskyDPTTitle) {
    turskyDPTTitle = turskyDPTTitle
  } else {
    turskyDPTTitle = ''
  }

  if (turskyDPTCategoryTitle) {
    turskyDPTCategoryTitleExt = turskyDPTCategoryTitle
  } else {
    turskyDPTCategoryTitleExt = ''
  }
}

function removeButton() {
  // $('.result-block > div').remove()
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    inputColor.val('#' + inputValue)
    // inputColor.trigger('change')
  })
})
